module.exports = __webpack_public_path__ + "static/media/swellWave.48ba229a.svg";